<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" @close="closeModal">
      <div class="fixed inset-0 z-30 overflow-y-auto">
        <div class="min-h-screen text-center flex">
          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0"
            enter-to="opacity-10"
            leave="duration-200 ease-in"
            leave-from="opacity-10"
            leave-to="opacity-0"
          >
            <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
          </TransitionChild>

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-50"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-50"
          >
            <div
              class="inline-block md:w-1/3 md:mx-auto my-5 mx-3 h-full max-w-screen-md m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded"
            >
              <div class="flex flex-row">
                <div class="flex-1"></div>
                <div
                  class="flex-4 pr-2 pt-2 cursor-pointer"
                  @click="closeModal"
                >
                  <XIcon class="text-brand-dark-gray w-7 h-7" ref="close" />
                </div>
              </div>

              <div class="pb-5 px-5 md:px-8">
                <h2 class="text-xl text-brand-black">Opt Out</h2>

                <p class="py-2">
                  Are you sure this property is
                  <span class="font-bold">not</span> located in
                  <span class="font-bold"> {{ criteria }}</span
                  >?
                </p>
                <p class="py-2">
                  Ignoring the requirements of this legislation may expose you
                  to legal action by the applicant.
                </p>

                <div class="flex py-5 justify-center">
                  <div class="mr-3">
                    <SecondaryButton @click="closeModal"
                      >Cancel</SecondaryButton
                    >
                  </div>
                  <div>
                    <button
                      class="w-full bg-brand-red border-2 border-brand-red hover:bg-red-700 text-white font-bold py-1 md:py-2 px-4 rounded focus:outline-none"
                      @click="optOut"
                      :disabled="isReportLoading"
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import { mapGetters } from "vuex"

import {
  TransitionRoot,
  TransitionChild,
  Dialog,
  DialogOverlay
} from "@headlessui/vue"

import { XIcon } from "@heroicons/vue/outline"

import { REPORT_FULFILL_REQUIREMENT, APPLICATION_GET } from "@/store/types"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    criteria: {
      type: String
    }
  },
  emits: ["close"],
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon
  },
  computed: {
    ...mapGetters(["isReportLoading"])
  },
  data() {
    return {}
  },
  methods: {
    closeModal() {
      this.$emit("close")
    },
    async optOut() {
      try {
        await this.$store.dispatch(REPORT_FULFILL_REQUIREMENT, {
          action: "opt_out"
        })
        const id = this.$route.params.id
        await this.$store.dispatch(APPLICATION_GET, { id })
        this.closeModal()
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
<style scoped></style>
